import { Component, Input, Output, EventEmitter, ContentChildren, QueryList, AfterContentInit } from '@angular/core';
import { TabItemComponent } from './tab-item.component'


export { TabItemComponent }

export interface TabChangeEvent {
    previousTabItem: TabItemComponent,
    newTabItem: TabItemComponent
}


@Component({
    moduleId: module.id.toString(),
    selector: 'yeti-tabs',
    template: require('./tab-host.html'),
    styles: [require('./tab-host.component.scss')]
})

export class TabHostComponent implements AfterContentInit {
    currentTabItem: TabItemComponent = null;
    priorTabItem: TabItemComponent = null;
    @ContentChildren(TabItemComponent) tabItems: QueryList<TabItemComponent>;

    @Output() tabChange = new EventEmitter<TabChangeEvent>();

    @Input() set navigateToTab(header: string) {
        if (!this.tabItems) {
            return;
        }
        let newTab = this.tabItems.filter(x =>  x.tabHeader.toLowerCase() === header.toLowerCase())[0];
        this.changeTab(newTab)
    }

    constructor() {
    }

    ngAfterContentInit() {
        let firstTabItem = this.tabItems.filter((thisTabItem) => {
            return thisTabItem.isActivated;
        })[0];

        if (!firstTabItem) {
            firstTabItem = this.tabItems.first;
        }

        if (firstTabItem) {
            this.changeTab(firstTabItem);
        }

        this.tabItems.changes.subscribe(() => {
            this.currentTabItem = this.tabItems.filter(x =>  x.isActivated)[0] || null;
        })
    }

    public revertNavigation() {
        this.currentTabItem.resetActivation(false);
        this.priorTabItem.resetActivation(true);
        this.currentTabItem = this.priorTabItem;
    }

    changeTab(tabItem: TabItemComponent) {

        if (!tabItem || tabItem === this.currentTabItem) {
            return;
        }

        this.priorTabItem = this.currentTabItem;
        if (this.currentTabItem) {

            this.currentTabItem.deactivate();
        }

        this.currentTabItem = tabItem;
        this.currentTabItem.activate();

        this.tabChange.emit({ previousTabItem: this.priorTabItem, newTabItem: tabItem });
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/reusable-components/tab-menu/tab-host.component.ts